// src/components/login/admin/deletion-impact-description.tsx
import { type DeletionImpact } from "@/api/brands";

/**
 * Human-readable summary of a deletion dry-run, for use inside a ConfirmDialog
 * description. Inline-only (no block-level elements) so it nests cleanly inside
 * the dialog's <p>. Shared by the user-delete and brand-delete admin flows.
 */
export function DeletionImpactDescription({
  preview,
  noun,
}: {
  preview: DeletionImpact | null;
  noun: string;
}) {
  if (!preview) return null;

  const tables = Object.keys(preview.impact).length;

  if (preview.total_rows === 0 && tables === 0) {
    return (
      <>
        No stored data was found for {noun}{" "}
        <strong>{preview.target}</strong>. Nothing will be deleted.
      </>
    );
  }

  return (
    <>
      This permanently removes{" "}
      <strong>
        {preview.total_rows.toLocaleString()} row
        {preview.total_rows === 1 ? "" : "s"}
      </strong>{" "}
      across <strong>{tables}</strong> table{tables === 1 ? "" : "s"} for {noun}{" "}
      <strong>{preview.target}</strong>.
      <br />
      <span style={{ color: "var(--infrared-coral)", fontWeight: 600 }}>
        This cannot be undone.
      </span>
    </>
  );
}
